import { showNotification } from "../utils/antdMessage";

const NotificationWithIcon = (type, message, description = "") => {
  showNotification(type, message, description);
};

export default NotificationWithIcon;
